interface BodyPanelProps {
    noPadding?: boolean;
    children: React.ReactNode;
}

const BodyPanel: React.FC<BodyPanelProps> = (props) => {
    return (
        <div
            className={`ibox-content ${
                props.noPadding ? "no-padding" : ""
            }`}
        >
            {props.children}
        </div>
    );
};
export default BodyPanel;
